import { useEffect, useState } from 'react'

import { useStep } from '../../hooks/use-step'
import { Step } from '../../utils/steps'
import { BottomText } from '../title-and-text/bottom-text'

import { AnimationStage } from './constants'
import { TextField } from './text-field'
import { VbarCard } from './vbar-card'

import style from './proofreader.module.scss'

const Proofreader = () => {
  const { step } = useStep()
  const [stage, setStage] = useState(AnimationStage.TextOnly)
  const [buttonPressed, setButtonPressed] = useState(false)
  const [cardDismissed, setCardDismissed] = useState(false)

  useEffect(() => {
    if (step !== Step.Proofreader) {
      setStage(AnimationStage.TextOnly)
      setButtonPressed(false)
      setCardDismissed(false)
      return
    }

    const timeoutIds: NodeJS.Timeout[] = []
    const startAnimate = () => {
      setButtonPressed(false)
      setCardDismissed(false)
      timeoutIds.push(
        setTimeout(() => {
          setStage(AnimationStage.WithVbar)
        }, 500),
        setTimeout(() => {
          setStage(AnimationStage.VbarCard)
        }, 3000),
        setTimeout(() => {
          setButtonPressed(true)
        }, 4500),
        setTimeout(() => {
          setCardDismissed(true)
        }, 5000),
        setTimeout(() => {
          setStage(AnimationStage.Reset)
        }, 7000),
        setTimeout(() => {
          setStage(AnimationStage.TextOnly)
        }, 7500),
      )
    }

    startAnimate()
    const interval = setInterval(() => {
      startAnimate()
    }, 7500)

    return () => {
      clearInterval(interval)
      for (const timeoutId of timeoutIds) {
        clearTimeout(timeoutId)
      }
    }
  }, [step])

  return (
    <div data-step={Step.Proofreader}>
      <div className={style.content} data-stage={stage}>
        {step === Step.Proofreader && (
          <>
            <TextField stage={stage} cardDismissed={cardDismissed} />
            <VbarCard stage={stage} cardDismissed={cardDismissed} buttonPressed={buttonPressed} />
          </>
        )}
      </div>
      <BottomText>Keep your writing error-free and perfectly polished.</BottomText>
    </div>
  )
}

export { Proofreader }
